import React, { useState } from "react";
import "./searchStops.css";
import TypographyComponent from "../../components/shared/typography/TypographyComponent";
import { TEXT } from "../../components/shared/typography/typographyConstants";
import AutocompleteComponent from "../../components/shared/autocomplete/AutocompleteComponent";
import { getBusStopsService } from "../../services/commonservices";
import StopInfoComponentSquare from "../stopInfoSquare/StopInfoComponentSquare";
import { useIntl } from "react-intl";
import {LOCATION__ARTEIXO, PLACEHOLDER_SEARCH, STOP__SELECT} from "../../translations/constans";

const SearchStopsComponent = () => {
  const [stop, setStop] = useState(null);
  const intl = useIntl();

  const stopsCallback = (response) => {
    setAutocompleteData({ ...autocompleteData, data: response.data });
  };

  const getStops = (value) => {
    getBusStopsService({ number_or_name: value }, stopsCallback);
  };

  const [autocompleteData, setAutocompleteData] = useState({
    id: 1,
    name: "name",
    placeholder: intl.formatMessage({ id: PLACEHOLDER_SEARCH }),
    handleValues: getStops,
    data: [],
  });

  const handleSelectBusStop = (item) => {
    setStop(item);
  };

  return (
    <>
      <section className="search-stops-header">
        <img
          alt="logo de arteixo"
          src="https://scdpastoriza.com//wp-content/uploads/2017/02/LOGO-ARTEIXO-SIMPLE.png"
          width="100"
          height="100"
          className="search-stops-header-logo"
        />
        <TypographyComponent
          text={intl.formatMessage({ id: LOCATION__ARTEIXO })}
          variant={TEXT.VARIANT_H1}
          className="search-stops-header-title"
        />
        <iframe
          name="iframe_aemet_id33044"
          width="100%"
          height="115px"
          tabIndex="0"
          id="iframe_aemet_id33044"
          src="https://www.aemet.es/es/eltiempo/prediccion/municipios/mostrarwidget/arteixo-baiuca-a-id15005?w=g1p01000001ohmffffffw87z112x4f86d9t95b6e9r0s8n2"
          frameBorder="0"
          scrolling="no"
        />
      </section>
      <section className="search-stops-input-container">
        <TypographyComponent
          text={intl.formatMessage({ id: STOP__SELECT })}
          variant={TEXT.VARIANT_H2}
        />
        <AutocompleteComponent
          data={autocompleteData}
          onClick={handleSelectBusStop}
        />
      </section>
      <section className="table-container">
        {!!stop && <StopInfoComponentSquare stopId={stop?.id} />}
      </section>
    </>
  );
};

SearchStopsComponent.propTypes = {};

export default SearchStopsComponent;
